<template>
    <div class="page-container">
        <div style="flex: 1; min-width: 80%">
            <Transition name="fade">
                <el-form
                    v-if="formVisible"
                    :inline="true"
                    label-position="top"
                    class="search-form"
                    :model="search_data"
                    style="padding: 0 20px"
                >
                    <el-form-item label="日期">
                        <el-date-picker
                            v-model="searchDate"
                            style="width: 250px"
                            type="daterange"
                            :disabled-date="disabledStopDate"
                            format="YYYY/MM/DD"
                            value-format="YYYY-MM-DD"
                            range-separator="到"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            placeholder="请选择日期"
                        />
                    </el-form-item>
                    <el-form-item label="告警内容">
                        <el-input v-model="search_data.desc" clearable placeholder="请输入告警内容" style="width: 150px" />
                    </el-form-item>
                    <el-form-item label="设备名称">
                        <el-input v-model="search_data.device_name" clearable placeholder="请输入设备名称" style="width: 150px" />
                    </el-form-item>
                    <el-form-item label="告警源">
                        <el-select v-model="search_data.code" placeholder="请选择告警源" style="width: 160px" clearable>
                            <el-option
                                v-for="(item, index) in codeOptionList"
                                :key="index.code"
                                :label="item.name"
                                :value="item.code"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="search_data.status" placeholder="请选择状态" style="width: 150px" clearable>
                            <el-option
                                v-for="(item, index) in [
                                    { name: '未处理', value: 0 },
                                    { name: '已确认', value: 1 }
                                ]"
                                :key="index.vlaue"
                                :label="item.name"
                                :value="Number(item.value)"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" :icon="Search" @click="getTableData">搜索</el-button>
                        <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                    </el-form-item>
                </el-form>
            </Transition>
            <el-card class="noBorder" style="flex: 1">
                <div style="display: flex; margin-bottom: 10px">
                    <!-- <el-button @click="handleExport" :icon="Download" v-permission="['device:mac:export']">导出</el-button> -->
                    <div class="card-header" style="margin-left: auto">
                        <div class="circle-btn">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                :content="formVisible ? '隐藏搜索' : '显示搜索'"
                                placement="top"
                            >
                                <el-button
                                    plain
                                    circle
                                    @click="formVisible = !formVisible"
                                    :icon="Search"
                                    size="small"
                                ></el-button>
                            </el-tooltip>
                            <el-tooltip class="box-item" effect="dark" content="刷新" placement="top">
                                <el-button plain circle @click="getTableData" :icon="Refresh" size="small"></el-button>
                            </el-tooltip>
                        </div>
                    </div>
                </div>
                <el-table :data="table_data" v-loading="tableLoading" :row-key="(row) => row.id" style="width: 100%" border>
                    <el-table-column label="序号" type="index" width="60" />
                    <el-table-column prop="report_time" width="155" label="发生时间"></el-table-column>
                    <el-table-column prop="name" width="150" label="名称"></el-table-column>
                    <el-table-column prop="level" width="90" label="告警级别">
                        <template #default="{ row }">
                            <span :style="{ color: levelOptionList[row.level].color }">
                                {{ levelOptionList[row.level].label }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="desc" label="告警内容" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="online" label="状态" width="80">
                        <template #default="{ row }">
                            <span v-if="row.status" style="color: #67c23a">已确认</span>
                            <span v-else style="color: #f56c6c">未处理</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="location" label="位置" show-overflow-tooltip>
                        <template #default="{ row }">
                            <span v-if="row.location">{{ row.location }}</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="80">
                        <template #default="{ row }">
                            <div>
                                <el-button
                                    v-if="row.status === 0"
                                    type="primary"
                                    link
                                    :icon="Check"
                                    size="small"
                                    @click="onCheckAlarm(row)"
                                >
                                    确认
                                </el-button>
                                <span v-else>-</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>

                <el-pagination
                    class="pagination"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="search_data.page"
                    :page-sizes="[10, 20, 50]"
                    :page-size="search_data.page_size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </el-card>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { batchAlarmConfirmCancel, getAlarmLogList } from '@/api//alarmList' // batchAlarmConfirmCancel
import { getAlarmLevelLists } from '@/api/eventConfig/alarmLevel/alarmLevel.js' // delAlarmLevel
import { getHistoryEventOption } from '@/api/history.js'
import { Check, Refresh, Search } from '@element-plus/icons' // Download
import { ElMessage } from 'element-plus'

const formVisible = ref(true)
const disabledStopDate = (time) => {
    return time.getTime() > Date.now()
}

// 重置
const resetQueryForm = () => {
    searchDate.value = []
    Object.keys(search_data.value).forEach((key) => {
        if (key !== 'page' && key !== 'page_size') search_data.value[key] = ''
    })
    getTableData()
}

const levelOptionList = ref({})
const codeOptionList = ref([])
const getOptionList = async () => {
    const res = await getAlarmLevelLists()
    if (res.length) {
        res.forEach((item) => {
            levelOptionList.value[item.level] = { ...item }
        })
    }
    // 获取告警编码选项
    codeOptionList.value = await getHistoryEventOption({ type: 2 })
}

// 数据源
const search_data = ref({
    desc: '',
    status: '',
    device_name: '',
    code: '',
    page: 1,
    page_size: 10
})
const searchDate = ref([])

const table_data = ref([])
const tableLoading = ref(true)
const total = ref(0)

// 获取列表数据
const getTableData = async () => {
    tableLoading.value = true
    if (!searchDate.value) {
        searchDate.value = ['', '']
    } else {
        search_data.value.start_time = searchDate.value[0]
        search_data.value.end_time = searchDate.value[1]
    }
    const result = await getAlarmLogList({ ...search_data.value })
    table_data.value = result.lists
    total.value = result.total
    tableLoading.value = false
}

// 分页相关
// page_size 改变触发
const handleSizeChange = (currentSize) => {
    search_data.value.page_size = currentSize
    getTableData()
}
// page 页码改变触发
const handleCurrentChange = (currentPage) => {
    search_data.value.page = currentPage
    getTableData()
}
const onCheckAlarm = async (data) => {
    try {
        await batchAlarmConfirmCancel('batch_confirm', [data.id])
        getTableData()
        ElMessage.success('确认成功')
    } catch (error) {}
}
// 切换到前台时候执行
onMounted(() => {
    getOptionList()
    getTableData()
})
</script>

<style lang="scss" scoped>
.page-container {
    width: 100%;
    display: flex;
}

.header {
    display: flex;
    align-items: center;

    .el-select,
    .el-input {
        margin-right: 10px;
    }
}
</style>
